import { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import DoctorMedicalMappingController from "../../controller/DoctorMedicalCenterMappingController";
import MedicalCenterController from "../../controller/MedicalCenterController";
import SubDepartmentController from "../../controller/SubDepartmentController";
import ServiceController from "../../controller/ServiceController";
import DoctorController from "../../controller/DoctorController";
import DoctorAssociateController from "../../controller/DoctorAssociateController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
    Container,
    Grid,
    useTheme,
    Box,
    FormControlLabel,
    Radio,
    Stack,
    Checkbox,
    TextField,
    FormGroup,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";
import AssociateController from "../../controller/DoctorAssociateController";


const INITIAL_FORM_STATE = {
    medicalCentreId: "",
    doctorId: "",
    willDoctorVisit: "",
    willAssociateVisit: "",
    associateId: "",
    visitDay: [],
    visitTimeFrom: "",
    visitTimeTo: "",
    wef: "",
};

const FORM_VALIDATION = Yup.object().shape({
    medicalCentreId: Yup.string().required("Medical Center is required"),
    doctorId: Yup.string().required("Doctor is required"),
    associateId: Yup.string().required("Associate is required"),
    willAssociateVisit: Yup.boolean()
        .required("Associate Visit is required")
        .oneOf([true, false], "Associate Visit must be selected"),
    willDoctorVisit: Yup.boolean()
        .required("Doctor Visit is required")
        .oneOf([true, false], "Doctor Visit must be selected"),

    // Optional: validate days only if willDoctorVisit is true
    visitDay: Yup.array().when("willDoctorVisit", {
        is: true,
        then: (schema) =>
            schema.min(1, "Select at least one visit day").required("Visit days are required"),
        otherwise: (schema) => schema.notRequired(),
    }),

    // Optional: validate time only if willDoctorVisit is true
    visitTimeFrom: Yup.string().when("willDoctorVisit", {
        is: true,
        then: (schema) => schema.required("Visit Time From is required"),
    }),
    visitTimeTo: Yup.string().when("willDoctorVisit", {
        is: true,
        then: (schema) => schema.required("Visit Time To is required"),
    }),

    // wef: Yup.date().required("WEF is required"),

});

let requestType = "";
const DoctorMedicalCenterMapping = () => {
    const doctorMedicalMappingController = new DoctorMedicalMappingController();
    const medicalCenterController = new MedicalCenterController();
    const doctorController = new DoctorController();
    const doctorAssociateController = new DoctorAssociateController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [medicalCenterOptions, setMedicalCenterOptions] = useState();
    const [doctorOptions, setDoctorOptions] = useState();
    const [associateOptions, setAssociateOptions] = useState();
    const [doctorMedicalCenterMapping, setDoctorMedicalCenterMapping] = useState([]);
    const [loader, setLoader] = useState(true);
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [popup, setPopUp] = useState(false);
    const [allUsers, setAllUsers] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllDoctorMedicalCenterMapping();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAllMedicalCenter = async () => {
        let caughtError;
        try {
            const response = await medicalCenterController.GetAllMedicalCenter(token);
            if (response.status === 200) {
                const medicalData = response?.data?.body?.map((item) => ({
                    // ...item,
                    centerLongName: item.centerLongName,
                    medicalCentreId: item._id,
                }));
                setMedicalCenterOptions(medicalData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllMedicalCenter",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllDoctor = async () => {
        let caughtError;
        try {
            const response = await doctorController.GetAllDoctor(token);
            if (response.status === 200) {
                const doctorData = response?.data?.body?.map((item) => ({
                    // ...item,
                    doctorName: item.doctorName,
                    doctorId: item._id,
                }));
                setDoctorOptions(doctorData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDoctor",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllAssociate = async () => {
        let caughtError;
        try {
            const response = await doctorAssociateController.GetAllAssociate(token);
            if (response.status === 200) {
                const assocData = response?.data?.body?.map((item) => ({
                    // ...item,
                    associateName: item.associateName,
                    associateId: item._id,
                }));
                setAssociateOptions(assocData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDoctor",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllDoctorMedicalCenterMapping = async () => {
        let caughtError;
        try {
            const response = await doctorMedicalMappingController.GetAllDoctorMedicalCenterMapping(token);
            if (response.status === 200) {
                const docdata = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setDoctorMedicalCenterMapping(docdata);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDoctorMedicalCenterMapping",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };


    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Medical Center Name", field: "centerLongName", width: 250 },
        { headerName: "Doctor Name", field: "doctorName", width: 210 },
        { headerName: "Associate Name", field: "associateName", width: 210 },
        { headerName: "Visit Days", field: "visitDay", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 210,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            // debugger
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedValues(() => currentRowData);
                            setMedicalCenterOptions([{
                                centerLongName: currentRow.centerLongName,
                                medicalCentreId: currentRow.medicalCentreId
                            }]);
                            setDoctorOptions([{
                                doctorName: currentRow.doctorName,
                                doctorId: currentRow.doctorId
                            }]);
                            setAssociateOptions([{
                                associateName: currentRow.associateName,
                                associateId: currentRow.associateId
                            }]);
                            // getAllService();
                            getAllMedicalCenter();
                            getAllDoctor();
                            getAllAssociate();
                            handleData();
                        } else {
                            doctorMedicalMappingController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllDoctorMedicalCenterMapping()
                                        showAlert("success", "Deleted successfully");
                                        setAllUsers((i) => {
                                            return allUsers.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "DoctorMedicalMapping onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const AddDoctorMedicalCenterMapping = async () => {
        getAllMedicalCenter();
        getAllDoctor();
        getAllAssociate();
        requestType = "Add";
        setUpdatedValues(() => INITIAL_FORM_STATE);
        handleData();
    };


    const submitValues = (submitValueData) => {
        // debugger
        let submitData = {};
        // tenantId coming from parent/component
        submitData.tenantId = tenantId;
        // Map form fields

        submitData.medicalCentreId = submitValueData?.medicalCentreId;
        submitData.doctorId = submitValueData?.doctorId;
        submitData.willDoctorVisit = submitValueData?.willDoctorVisit;
        submitData.willAssociateVisit = submitValueData?.willAssociateVisit;
        submitData.associateId = submitValueData?.associateId;
        submitData.visitDay = submitValueData?.visitDay;
        submitData.visitTimeFrom = submitValueData?.visitTimeFrom;
        submitData.visitTimeTo = submitValueData?.visitTimeTo;
        submitData.wef = submitValueData?.wef;



        //add for image
        if (requestType === "Edit") {
            // debugger
            submitData.id = submitValueData?.id;
            const departmentId = submitValueData?.id;
            // assuming ID comes from backend
            doctorMedicalMappingController
                .Update(departmentId, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllDoctorMedicalCenterMapping()
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.data?.status === 204)
                            showAlert("error", response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            doctorMedicalMappingController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllDoctorMedicalCenterMapping()
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 409) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);

    const weekDays = [
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
    ];
    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <h6 className="breadsub">Medical</h6>
                                        </li>
                                        <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>Doctor MedicalCenter Mapping</h6>
                                        </li>
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="adduser">
                        <Controls.ActionButton onClick={() => AddDoctorMedicalCenterMapping()}>
                            <span>Add New</span>
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item xs={12} className="formBg">
                        <Container maxWidth="md" className="formClwidth">
                            <div>
                                <Controls.Grid
                                    columns={columns}
                                    data={doctorMedicalCenterMapping}
                                    fileName={"DoctorMedicalCenterMapping"}
                                />
                                {popup && (
                                    <Controls.Popup
                                        title="Doctor MedicalCenter Mapping"
                                        openPopup={popup}
                                        setOpenPopup={handlePopup}
                                    >
                                        <Formik
                                            enableReinitialize
                                            initialValues={{
                                                ...(updatedValues || INITIAL_FORM_STATE),
                                            }}
                                            validationSchema={FORM_VALIDATION}
                                            onSubmit={(values) => submitValues(values)}
                                        >
                                            {({ values, handleChange, setFieldValue }) => (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="medicalCentreId"
                                                                value={
                                                                    medicalCenterOptions?.find(
                                                                        (opt) => opt.medicalCentreId === values.medicalCentreId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Medical Center <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={medicalCenterOptions || []}
                                                                getOptionLabel={(option) => option?.centerLongName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.medicalCentreId === value?.medicalCentreId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("centerLongName", value ? value.centerLongName : ""); // ✅ only save string
                                                                    setFieldValue("medicalCentreId", value ? value.medicalCentreId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="doctorId"
                                                                value={
                                                                    doctorOptions?.find(
                                                                        (opt) => opt.doctorId === values.doctorId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Doctor <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={doctorOptions || []}
                                                                getOptionLabel={(option) => option?.doctorName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.doctorId === value?.doctorId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("doctorName", value ? value.doctorName : ""); // ✅ only save string
                                                                    setFieldValue("doctorId", value ? value.doctorId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="associateId"
                                                                value={
                                                                    associateOptions?.find(
                                                                        (opt) => opt.associateId === values.associateId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select Associate Name <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={associateOptions || []}
                                                                getOptionLabel={(option) => option?.associateName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.associateId === value?.associateId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("associateName", value ? value.associateName : ""); // ✅ only save string
                                                                    setFieldValue("associateId", value ? value.associateId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            Doctor Visit
                                                            <Controls.RadioButton name="willDoctorVisit" row>
                                                                <FormControlLabel value={true} control={<Radio />} label="YES" />
                                                                <FormControlLabel value={false} control={<Radio />} label="NO" />
                                                            </Controls.RadioButton>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            Associate Visit
                                                            <Controls.RadioButton name="willAssociateVisit" row>
                                                                <FormControlLabel value={true} control={<Radio />} label="YES" />
                                                                <FormControlLabel value={false} control={<Radio />} label="NO" />
                                                            </Controls.RadioButton>
                                                        </Grid>
                                                        {/* {values.willDoctorVisit || values.willAssociateVisit && ( */}
                                                        <Grid item xs={12} md={6}>
                                                            Visit Days
                                                            <FormGroup row>
                                                                {weekDays.map((day) => (
                                                                    <FormControlLabel
                                                                        key={day}
                                                                        control={
                                                                            <Checkbox
                                                                                name="visitDay"
                                                                                value={day}
                                                                                checked={values.visitDay?.includes(day)}
                                                                                onChange={handleChange}
                                                                            />
                                                                        }
                                                                        label={day}
                                                                    />
                                                                ))}
                                                            </FormGroup>
                                                        </Grid>
                                                        {/* )} */}
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                label="Visit Time From"
                                                                name="visitTimeFrom"
                                                                type="time"
                                                                value={values.visitTimeFrom || ""}
                                                                onChange={handleChange}
                                                                InputLabelProps={{ shrink: true }}
                                                                fullWidth
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                label="Visit Time To"
                                                                name="visitTimeTo"
                                                                type="time"
                                                                value={values.visitTimeTo || ""}
                                                                onChange={handleChange}
                                                                InputLabelProps={{ shrink: true }}
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={4} md={2} className="marginAuto">
                                                        <Controls.Button>Submit</Controls.Button>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Controls.Popup>
                                )}
                            </div>
                        </Container>
                    </Grid>
                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box >
        </>
    );
};

export default DoctorMedicalCenterMapping;
